import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/common/apis'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		is_login:true,
		base:{
			is_wxpay:0,
			is_balancepay:0,
			title:"",
			theme_color:"#ff5555",
			btn_color:"#ff5555",
			font_color:"#ffffff",
		},
		fenxiao:{},
		return_set:{},
		scoreshop:{},
		transfer_account:{},
		agent:{},
		double_track:{},
		user:{},
		token:""
	},
	mutations: {
		setConfig(state,data){
			console.log('setConfig',data);
			state.base = data;
			state.fenxiao = data.fenxiao;
			if(data.fenxiao) state.fenxiao = data.fenxiao;
			if(data.return) state.return_set = data.return;
			if(data.transfer_account) state.transfer_account = data.transfer_account;
			if(data.scoreshop) state.scoreshop = data.scoreshop;
			if(data.agent) state.agent = data.agent;
			if(data.double_track) state.double_track = data.double_track;
			localStorage.setItem("wxapp_login",data.wxapp_login);
			localStorage.setItem("theme_style",`--main-color: ${data.theme_color};`);
			localStorage.setItem("theme_color",data.theme_color);
		},
		setUser(state,data){
			state.user = data;
			state.is_login = true; 
			state.token = data.token;
			localStorage.setItem("token",state.token);
		},
		setLogin(state,data){
			state.is_login = data;
		},
		setToken(state,data){
			state.token = data;
			localStorage.setItem("token",state.token);
		},
		logout(state,data){
			state.is_login = false;
			state.user = {};
			state.token = "";
			localStorage.removeItem("token");
		}
	},
	getters: {
		is_login:state => state.is_login,  
		base:state => state.base,
		fenxiao:state => state.fenxiao,
		return_set:state => state.return_set,
		scoreshop:state => state.scoreshop,
		transfer_account:state => state.transfer_account,
		agent:state => state.agent,
		double_track:state => state.double_track,
		user:state => state.user,
		token:state => state.token
	},
	actions: {
		getConfig({commit},sCallback){
			api.getConfig().then(res => {
				if(res.code == 1){
					commit('setConfig', {
						...res.data,
						category: res.data.category.filter(item => item.title != '商城')
					});
					localStorage.setItem("platform","H5");
					// 设置logo
					document.title = res.data.title;
					document.querySelector('link[rel="icon"]').href = res.data.logo;
					sCallback && sCallback(res.data);
					
				}
			}).catch(err => {
				console.log(err);
			});
			
		},
		logout({state,commit}){
			commit('logout', {});
		},
		setInitLogin({state,dispatch,commit}){
			let token = "";
			
			token = localStorage.getItem("token");

			
			if(process.env.NODE_ENV == 'development'){
				token = localStorage.getItem("token");
			}
			
			if(token){
				commit('setLogin', true);
				commit('setToken', token);
			}
		},
		getUser({state,commit},sCallback){
			return new Promise((resolve,reject)=>{
				api.getUserInfo().then(res => {
					if(res.code == 1){
						commit('setUser', res.data);
						sCallback && sCallback(res.data);
						resolve(res.data);
					}
					else{
						commit('logout', {});
						resolve(res.data);
					}
				}).catch(err => {
					commit('logout', {});
					resolve({
						code: 10000,
						message: err.message || err.msg || "获取用户信息失败"
					});
				});
			})
		}
	}
})

export default store
